export default __webpack_public_path__ + "static/media/white.707feb96.png";